import { SnapWorkOrderCostParams } from '@calculations/cost';

import { QuoteBuilderWorkOrderType } from '../../types/state/work-order';

export function storeToCalculationSnapWorkOrder(
  snapWorkOrder: QuoteBuilderWorkOrderType,
): Omit<SnapWorkOrderCostParams, 'quantity'> {
  const {
    hasSubWorkOrders,
    hasNestedRequirementWorkOrders,
    snapOperationUuids,
    snapOperations,
    enableUnsupportedCalculationsFlag,
  } = snapWorkOrder;

  const operations = uuidMap(snapOperationUuids, snapOperations);

  return {
    snapWorkOrder: {
      hasSubWorkOrders,
      hasNestedRequirementWorkOrders,
      enableUnsupportedCalculationsFlag,
      snapOperations: operations.map(
        ({ snapRequirementUuids, snapRequirements, ...operation }) => ({
          ...operation,
          snapRequirements: uuidMap(snapRequirementUuids, snapRequirements),
        }),
      ),
    },
  };
}

function uuidMap<T>(uuids: string[], records: Record<string, T>): T[] {
  return uuids.map((uuid) => records[uuid]);
}
